<template>
  <b-card class="m-2 black-box-secondary bg-light">
    <b-card-text>
      <b-row>
        <b-col md="8">
          <span style="font-weight: 600">{{ nomeTipo }}</span>
        </b-col>
        <b-col md="4" class="bottoni">
          <div class="rounded-pill bg-white text-center p-2" style="text-transform: uppercase">
            {{ item.src_language.id }} <span class="flag">{{ item.src_language.flag }}</span>
            <b-icon icon="chevron-right" font-scale="1" class="mx-2"></b-icon>
            {{ item.dest_language.id }} <span class="flag">{{ item.dest_language.flag }}</span>
            <b-icon-music-note
              v-if="item.request_audio"
              title="E' richiesta anche la lettura audio"
              v-b-tooltip.hover
            ></b-icon-music-note>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8" class="bottoni">
          <a @click="showNote(item.note)" class="text-primary" v-if="item.note" href="#"> Note </a><br />
          Richiesta da: {{ item.requester.first_name }} {{ item.requester.last_name }} <br />
          Consegna: <span v-if="item.due_date">{{ item.due_date | moment("DD/MM/YYYY") }}</span>
          <span v-if="!item.due_date" class="text-muted">non specificata</span>
        </b-col>
        <b-col md="4" class="text-right bottoni">
          <br />
          <b-button
            pill
            @click.prevent="download(`${item.id}/original/${item.name}`)"
            variant="outline-primary"
            class="btn-circle"
            v-b-tooltip.hover
            title="Scarica Documento Originale"
          >
            <b-icon-file-earmark></b-icon-file-earmark>
          </b-button>
          <b-button
            pill
            @click="delItem(item.id, index)"
            variant="outline-secondary"
            v-if="item.status_id == 1"
            class="ml-2 btn-circle"
            v-b-tooltip.hover
            title="Elimina Richiesta"
          >
            <b-icon-trash></b-icon-trash>
          </b-button>
        </b-col>
      </b-row>
    </b-card-text>
  </b-card>
</template>

<script>
import "vue2-datepicker/locale/it";
import myMixing from "@/mixing/util";

export default {
  name: "CardOrg1",
  mixins: [myMixing],
  props: ["item", "status", "index"],
  data() {
    return {};
  },
  methods: {
    delItem(document_id, element_index) {
      this.$parent.delItem(document_id, element_index);
    },
    showNote(note) {
      this.$bvModal.msgBoxOk(note, { title: "Note del Richiedente" });
    },
  },
};
</script>
<style>
.bg-light {
  background: #efeeec !important;
}
</style>
